import NiceModal from "@ebay/nice-modal-react";
import { requester } from "App";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import FlexChild from "layouts/flex/FlexChild";

import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import ModalBase from "modals/base/ModalBase";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
// import { HOST } from "routes/front/main/WebSocketContainer";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import waitForItemCollection from "resources/img/waitForItemCollection.png";
import waitForItemCollectionSound from "resources/music/waitForItemCollectionSound.mp3";



const WaitForItemCollectionModal = NiceModal.create(props => {
    const { t } = useTranslation();
    const [withHeader, withFooter] = [false, false];
    const [width, height] = ["80%", "50%"];
    const withCloseButton = false;
    const modal = useRef();
    const clickOutsideToClose = false;
    const title = t("");
    const buttonText = t("close");
    const audioRef = useRef();

    useEffect(() => {
        return(
            audioRef.current.play()
        );
    },[])



    return (
        <ModalBase
            ref={modal}
            width={width}
            height={height}
            withHeader={withHeader}
            withFooter={withFooter}
            withCloseButton={withCloseButton}
            clickOutsideToClose={clickOutsideToClose}
            title={title}
            buttonText={buttonText}
            overflow={"visible"}
            borderRadius={"25px"}
            onClose={props.onClose}
        >
            <audio ref={audioRef} src={waitForItemCollectionSound} preload="auto" />
            <VerticalFlex padding={"4vw"} gap={30}>
                <FlexChild height={"max-content"}>
                        <P color={"black"} font={"gmarketSansBold"} weight={"bold"} size={"3.2vw"}>잠시만 기다려주세요</P>
                        {/* <P size={17}>구매해주셔서 감사합니다.</P> */}
                </FlexChild>
                <FlexChild height={"2px"} backgroundColor={"#eee"} />
                <FlexChild height={"max-content"}>
                    <P font={"gmarketSansBold"} color={"#3E3E3E"} size={"3vw"}>먼저 구매한 고객님이 물건을 수령 중이에요.</P>
                    <P font={"gmarketSansBold"} color={"#3E3E3E"} size={"3vw"}>잠시만 기다려주세요.</P>
                </FlexChild>
                <FlexChild>
                    <img src={waitForItemCollection} width={"70%"} />
                </FlexChild>
                    
                
            </VerticalFlex>
        </ModalBase>
    );
});

export default WaitForItemCollectionModal;
